import { Button, Form, Row, Space, theme } from "antd";
import { useEffect } from "react";
import { useSetting } from "../../util/settings";
import FormItem from "../../form/form-item";

export const useContractSetting = () => {
  return useSetting("contracts", "application", {
    contractLocation: "Lünen",
    marginLeft: 30,
    marginRight: 30,
    marginTop: 40,
    marginBottom: 30,
  })
}

function ContractSettingsPage() {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const [contractSetting, updateContractSetting] = useContractSetting();

  const formStyle: React.CSSProperties = {
      maxWidth: 'none',
      background: token.colorFillAlter,
      borderRadius: token.borderRadiusLG,
      padding: 24,
    };

  useEffect(() => {
    form.setFieldsValue(contractSetting)
  }, [form, contractSetting])

  return (
    <Form form={form} name="advanced_search" style={formStyle} onFinish={updateContractSetting}>
      <Row><h3>Vertragseinstellungen</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="contractLocation" label="Unterschrift Ort" />
        <FormItem fieldName="contractSignerLine1" label="Unterschrift Unterzeichner Z.1" />
        <FormItem fieldName="contractSignerLine2" label="Unterschrift Unterzeichner Z.2" />
        <FormItem fieldName="contractSignature" label="Unterschrift" type="base64Img" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="fontSize" label="Schriftgröße" type="number" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="marginLeft" label="Seitenrand links"  type="number" />
        <FormItem fieldName="marginRight" label="Seitenrand rechts" type="number" />
        <FormItem fieldName="marginTop" label="Seitenrand oben" type="number" />
        <FormItem fieldName="marginBottom" label="Seitenrand unten" type="number" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="marginTopHeader" label="Header Rand oben" type="number" />
        <FormItem fieldName="marginBottomFooter" label="Footer Rand unten" type="number" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="logo" label="Logo" type="base64Img" />
        <FormItem fieldName="logoInContracts" label="Logo bei Verträgen" type="check" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="footerFontColor" label="Footer Schriftfarbe" />
        <FormItem fieldName="footerFontSize" label="Footer Schriftgröße" type="number" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="otherCss" label="Anderes CSS" type="text" />
        <FormItem fieldName="otherCssLetter" label="Anderes CSS Anschreiben" type="text" />
      </Row>
      <div style={{ textAlign: 'right' }}>
        <Space size="small">
          <Button loading={false} type="primary" htmlType="submit">
            Speichern
          </Button>
        </Space>
      </div>
    </Form>
  )
}

export default ContractSettingsPage;